import { AJAX_TIMEOUT_MESSAGE } from '../helpers.js';
import * as FieldValidation from '../shared/field-validation.js';
import {
    buildAddPaymentMethodPayload,
    formatCardNumberInput,
} from '../shared/payment-method-form.js';
import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { initCardOtpModal, requestCardOtpVerification } from './card-otp-modal.js';
import { getMemberOverlayElement, showOverlay, hideOverlay } from '../shared/overlay.js';
import { openIndexPage } from './member-open-index-page.js';
import { showAlertMsg } from './member-show-alert-msg.js';
import { initPaymentSharingPromptModal, showPaymentSharingPromptModal } from '../shared/payment-sharing-prompt-modal.js';

const ADD_FIELDS = {
    name: '#name',
    card: '#card',
    expiryMonth: '#expiry_month',
    expiryYear: '#expiry_year',
    cvv2: '#cvv2',
    avsZip: '#avs_zip',
    useOtp: '#use_otp',
};

export function initAddCardModal() {
    function getModal() {
        return $('#addCardModal');
    }

    function getConfig() {
        return JSON.parse(
            (document.getElementById('add-card-modal-config') || {}).textContent || '{}'
        );
    }

    let cardType = 'credit';

    function setCardType(type) {
        const $modal = getModal();
        if (cardType && cardType !== type) {
            $modal.find('#card, #cvv2, #expiry_month, #expiry_year, #avs_zip').val('');
        }
        cardType = type;
        const $types = $modal.find('.manual-card-form__card-type');
        $types.removeClass('is-selected').attr('aria-pressed', 'false');
        $types
            .filter('[data-card-type="' + type + '"]')
            .addClass('is-selected')
            .attr('aria-pressed', 'true');
        $modal.find('#avs_zip').prop('required', type === 'credit');
        FieldValidation.syncCvvFieldForCardType($modal.find('#cvv2'), type);
    }

    function closeModal() {
        const $modal = getModal();
        $modal.modal('hide');
        $modal.find('#name, #card, #expiry_month, #expiry_year, #cvv2, #avs_zip').val('');
        $modal.find('#use_otp').prop('checked', false);
        $modal.find('#avs_zip').prop('required', true);
        FieldValidation.syncCvvFieldForCardType($modal.find('#cvv2'), 'credit');
    }

    function readAddFieldsFromModal() {
        const $modal = getModal();
        return {
            name: $modal.find(ADD_FIELDS.name).val(),
            card: $modal.find(ADD_FIELDS.card).val(),
            expiryMonth: $modal.find(ADD_FIELDS.expiryMonth).val(),
            expiryYear: $modal.find(ADD_FIELDS.expiryYear).val(),
            cvv2: $modal.find(ADD_FIELDS.cvv2).val(),
            avsZip: $modal.find(ADD_FIELDS.avsZip).val(),
            useOtp: $modal.find(ADD_FIELDS.useOtp).prop('checked'),
        };
    }

    function validateAndSubmit(e) {
        e.preventDefault();
        const config = getConfig();
        const $modal = getModal();

        if (!FieldValidation.validateCardPaymentFields($modal[0], null, { requireCreditFields: cardType === 'credit' })) {
            return;
        }

        showOverlay(getMemberOverlayElement());

        let payload;
        try {
            payload = buildAddPaymentMethodPayload(
                Object.assign(readAddFieldsFromModal(), { cardType: cardType }),
                {
                    user_type: config.userType,
                    gate_id: config.gatewayId,
                    _token: config.csrfToken,
                }
            );
        } catch (err) {
            hideOverlay(getMemberOverlayElement());
            showAlertMsg(err, 'danger');
            return;
        }

        if (payload.use_otp === 'true') {
            hideOverlay(getMemberOverlayElement());
            $modal.modal('hide');
            requestCardOtpVerification(payload, config.confirmOtpUrl, handleSaveResponse);
            return;
        }

        $.ajax({
            url: config.saveUrl,
            type: 'POST',
            data: payload,
            success: function (response) {
                hideOverlay(getMemberOverlayElement());
                handleSaveResponse(response);
            },
            error: function () {
                hideOverlay(getMemberOverlayElement());
                closeModal();
                cleanupBootstrapModalBody();
                showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
                openIndexPage();
            },
        });
    }

    function handleSaveResponse(response) {
        const config = getConfig();
        if (!response.success) {
            showAlertMsg(response.error, 'danger');
            return;
        }
        closeModal();
        cleanupBootstrapModalBody();
        localStorage.clear();
        $.ajax({
            url: config.reloadUrl,
            type: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            success: function (data) {
                $('#index_paging').empty().html(data).fadeIn('slow', function () {
                    showAlertMsg('The credit card was successfully added to your account');
                });
                if (response.prompt_payment_sharing) {
                    initPaymentSharingPromptModal();
                    showPaymentSharingPromptModal();
                }
            },
            error: function () {
                showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
                openIndexPage();
            },
        });
    }

    $(document)
        .off('show.bs.modal.addCardModal', '#addCardModal')
        .on('show.bs.modal.addCardModal', '#addCardModal', function () {
        cardType = 'credit';
        if (getConfig().hasAlternativeCards) {
            setCardType('credit');
        }
        FieldValidation.applyCardConstraints($(this));
        $(this).find('[data-toggle="tooltip"]').tooltip();
        if (!getConfig().kioskValidated) {
            FieldValidation.applyCardMasks($(this));
        }
    });

    $(document)
        .off('input.addCardModal', '#card')
        .on('input.addCardModal', '#card', function () {
        formatCardNumberInput(this);
    });
    $(document)
        .off('click.addCardModalType', '#addCardModal .manual-card-form__card-type')
        .on('click.addCardModalType', '#addCardModal .manual-card-form__card-type', function () {
        setCardType(this.getAttribute('data-card-type'));
    });
    $(document)
        .off('click.addCardModalClose', '[data-action="close-add-card"]')
        .on('click.addCardModalClose', '[data-action="close-add-card"]', function (e) {
        e.preventDefault();
        closeModal();
    });
    $(document)
        .off('submit.addCardModal', '#addCCtoAccount')
        .on('submit.addCardModal', '#addCCtoAccount', validateAndSubmit);

    if (document.getElementById('cardOtpModal')) {
        initCardOtpModal();
    }
}
